import _sfc_main from "./component-library167.mjs";
import "./component-library168.mjs";
import normalizeComponent from "./component-library92.mjs";
var _sfc_render = function render() {
  var _a;
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _setup.energyLabel || _vm.energyClass ? _c("div", { staticClass: "energy-label", class: _setup.containerClass }, [_setup.energyClassName ? _c(_setup.Icon, { attrs: { "energy-class": _setup.energyClassName, "reverse": _vm.reverse }, on: { "click": _setup.openEnergyModal } }) : _vm._e(), ((_a = _setup.energyLabel) == null ? void 0 : _a.products) && _setup.energyLabel.products.length > 0 && !_vm.noDataSheet ? _c(_setup.Datasheet, { staticClass: "energy-label__datasheet", attrs: { "align-dropdown": _setup.alignDropdown, "is-internal-link": _vm.isInternalLink, "products": _setup.energyLabel.products }, on: { "open-document": (args) => _vm.$emit("open-document", args) } }) : _vm._e()], 1) : _vm._e();
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "67ef960f",
  null,
  null
);
const EnergyLabel = __component__.exports;
export {
  EnergyLabel as default
};
